module.exports = __webpack_public_path__ + "img/time-icon.9c3ca7ee.svg";